/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */

import React from 'react';
import { Providers } from '@tripian/model';

import GygTourInfoForm from './GygTourInfoForm/GygTourInfoForm';

interface IGygTourInfo {
  tour: Providers.Gyg.Tour;
  date: moment.Moment;
  adult?: number;
  child?: number;
  test?: boolean;

  apiTourAvailabilities: (tourId: number, startDate: string, endDate?: string, language?: string, currency?: string) => Promise<Providers.Gyg.TourAvailability[]>;
  apiOptions: (tourId: number, language?: string, currency?: string) => Promise<Providers.Gyg.TourOption[]>;
  apiOptionPricings: (optionId: number, language?: string, currency?: string) => Promise<Providers.Gyg.TourOptionPricing>;
  apiOptionAvailabilities: (optionId: number, startDate: string, endDate?: string | undefined, language?: string | undefined, currency?: string | undefined) => Promise<Providers.Gyg.TourAvailability[]>;
  apiBookingAdd: (tourBookingRequest: Providers.Gyg.TourBookingRequest) => Promise<Providers.Gyg.TourBooking>;
  apiPaymentConfiguration: (language?: string, currency?: string, country?: string) => Promise<Providers.Gyg.PaymentConfiguration[]>;
  apiCartAdd: (tourBookingCartRequest: Providers.Gyg.TourBookingCartRequest) => Promise<Providers.Gyg.TourBookingCart>;
}

const GygTourInfo: React.FC<IGygTourInfo> = ({
  tour,
  date,
  adult = 1,
  child = 0,
  test = true,

  apiTourAvailabilities,
  apiOptions,
  apiOptionPricings,
  apiOptionAvailabilities,
  apiBookingAdd,
  apiPaymentConfiguration,
  apiCartAdd,
}) => {
  const creditCard = test
    ? {
        number: '6771798025000004',
        cvc: '737',
        holderName: 'MyFirstName MyLastName',
        expiryMonth: '03',
        expiryYear: '2030',
      }
    : {
        number: '',
        cvc: '',
        holderName: '',
        expiryMonth: '',
        expiryYear: '',
      };

  const dateString = date.format('YYYY-MM-DDTHH:mm:ss');

  return (
    <div>
      <div className="row center">
        <h1 className="pt4 pb2">{tour.title}</h1>
        <div className="col col12">
          <GygTourInfoForm
            tour={tour}
            date={date}
            adult={adult}
            child={child}
            test={test}
            apiTourAvailabilities={apiTourAvailabilities}
            apiOptions={apiOptions}
            apiOptionPricings={apiOptionPricings}
            apiOptionAvailabilities={apiOptionAvailabilities}
            apiBookingAdd={apiBookingAdd}
            apiPaymentConfiguration={apiPaymentConfiguration}
            apiCartAdd={apiCartAdd}
          />
        </div>
      </div>
      <br />
      <span>Tour Id: {tour.tour_id}</span>
      <br />
      <span>Date: {dateString}</span>
      <br />
      <span>Adult: {adult}</span>
      <br />
      <span>Child: {child}</span>
      <br />
      <span>Credit Card: {JSON.stringify(creditCard)}</span>
      <br />
    </div>
  );
};

export default GygTourInfo;
